// @refresh reset
import React from "react";
import { Button as AntdButton, type ButtonProps as AntdButtonProps } from "antd";
import { FiExternalLink } from "react-icons/fi";
import V2Spinner from "./V2Spinner";

type ButtonProps = AntdButtonProps & {
  isExternal?: boolean;
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, isExternal, loading, style, ...props }, ref) => {
    const externalStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    // Use V2Spinner as the loading icon if loading is true
    const loadingConfig = loading === true
      ? { delay: 0, icon: <V2Spinner size="small" /> }
      : loading;

    const buttonStyle = isExternal ? { ...style, ...externalStyle } : style;

    return (
      <AntdButton
        {...props}
        ref={ref}
        loading={loadingConfig}
        style={buttonStyle}
      >
        {children}
        {isExternal && (
          <span className="button__external_icon">
            <FiExternalLink />
          </span>
        )}
      </AntdButton>
    );
  }
);

Button.displayName = "Button";

export default Button;
